import React, { useEffect, useState, useCallback, useMemo } from 'react';

import TicketServices from 'services/ticket.service';

import { ITicketTable } from './interface';
import { ITicketsData } from 'models/Ticket';
import { modelLinkTicket } from './models';
import { IBatchRequestResponse } from 'models/Batch';

import Table from '..';
import KeycloakPubServiceInstance from 'services/keycloakpubsub.service';
import store from 'store';
import { RootState } from 'store/ducks';
import { useDispatch, useSelector } from 'react-redux';
import { DateOutputStr } from 'utils/DateOutput';
import TableSearchOPenProtocol from 'components/TableSearchOpenProtocol';

const LinkTicketProtocol: React.FC<ITicketTable> = (props) => {
  const user = useSelector((state: RootState) => state.user);
  const dispatch = useDispatch();

  const {
    showButton,
    trackingKey,
    showFilter,
    completeBlankSpaces,
    tabFilter,
    model,
    initialOrder,
    refreshTable,
    protocolNumber,
    isEditing,
    customerId
  } = props;

  const [tickets, setTickets] = useState<IBatchRequestResponse<ITicketsData>>();
  const [tableFilter, setTableFilter] = useState<any>({
    and: [
      // {
      //   customerId: {
      //     eq: customerId
      //   },
      // },
      {
        createdDate: {
          ge: new Date(
            `${DateOutputStr(
              getMinDate().toISOString(),
              'yyyy-MM-dd'
            )}T00:00:00.000Z`
          ),
        },
      },
      {
        createdDate: {
          le: new Date(
            `${DateOutputStr(
              getMaxDate().toISOString(),
              'yyyy-MM-dd'
            )}T23:59:59.999Z`
          ),
        },
      }
    ],
  });
  const [tableOrder, setTableOrder] = useState(
    initialOrder || 'createdDate desc'
  );
  const [currentPage, setCurrentPage] = useState(0);
  // eslint-disable-next-line react/destructuring-assignment
  let pageSizeProp = props.pageSize || 10;
  const formatedModel: any = [...((model as any) || (modelLinkTicket as any))];

  const getTickets = useCallback(async () => {
    setTickets(undefined);

    let newFilter = tableFilter;

    if (tableFilter.and.and) {
      if (customerId) {
        newFilter.and.and.push({ customerId: { eq: customerId } });
      }

      if (isEditing) {
        newFilter.and.and.push({ protocolNumber: { ne: JSON.parse(protocolNumber) } });
      }
    } else {
      if (customerId) {
        newFilter.and.push({ customerId: { eq: customerId } });
      }

      if (isEditing) {
        newFilter.and.push({ protocolNumber: { ne: JSON.parse(protocolNumber) } });
      }
    }

    await new TicketServices()
      .get(currentPage, pageSizeProp, tableOrder, { ...tabFilter, ...newFilter })
      .then((result: IBatchRequestResponse<ITicketsData> | undefined) => {
        if (result) {
          const { error, data, totalPages, pageSize, total } = result;

          dispatch({ type: 'SET_PROTOCOLS', data: data });
          setTickets({ error, data: data, totalPages, pageSize, total });
        }
      });
  }, [tableOrder, tableFilter, currentPage, store.getState().customer]);

  const bottomButton = {
    label: '+ Ver todos os protocolos',
    linkTo: '/protocolos',
  };

  function getMinDate() {
    const minDate = new Date(new Date().toDateString());
    minDate.setMonth(minDate.getMonth() - 3);
    return minDate;
  }

  function getMaxDate() {
    return new Date(new Date().toDateString());
  }

  const TicketsTableRender = useMemo(
    () => (
      <Table
        trackingKey={trackingKey}
        data={tickets?.data}
        error={tickets?.error}
        tableOrder={tableOrder}
        setTableOrder={setTableOrder}
        onReload={getTickets}
        currentPage={currentPage}
        DropdownTemplate={props.DropdownTemplate || undefined}
        className="mt-3"
        totalPages={tickets?.totalPages}
        pageSize={pageSizeProp}
        bottomButton={showButton ? bottomButton : undefined}
        completeBlankSpaces={completeBlankSpaces || false}
        onPageChange={setCurrentPage}
        model={formatedModel}
      />
    ),
    [tickets, user?.selectedCustomerId]
  );

  useEffect(() => {
    KeycloakPubServiceInstance.subscribe(() => {
      getTickets();
    });
  }, [getTickets, refreshTable, user?.selectedCustomerId]);

  function setFilter(value: any) {
    function setValue(valueProp: any) {
      return valueProp.toString().length >= 3
        ? { contains: valueProp.toLowerCase() }
        : { eq: valueProp.toLowerCase() };
    }
    return [
      {
        or: {
          'tolower(description)': setValue(value),
          'tolower(customerName)': setValue(value),
        },
      },
      { protocolNumber: { eq: Number(value) } },
    ];
  }

  return (
    <>
      {showFilter && (
        <TableSearchOPenProtocol
          trackingKey="Grid Protocolos"
          inputFilter={{
            placeholder: 'Nº do protocolo, assunto ou cliente',
            filters: (value) => setFilter(value),
          }}
          dateKey="createdDate"
          setTableFilter={setTableFilter}
          tableOrderBy={tableOrder}
          setTableOrderBy={setTableOrder}
          statusLabel="Situação"
          setCurrentPage={setCurrentPage}
          dateMin={getMinDate()}
          dateMax={getMaxDate()}
          showGroupSelect={false}
          ShowStatusSelect
          clearBtn={false}
          className={'no-margin-search'}
          protocolNumber={protocolNumber}
        />
      )}
      {TicketsTableRender}
    </>
  );
};

export default LinkTicketProtocol;
